/** Default hardware selection (6× RASA 11 + ZWO 6200). */
export const DEFAULT_HARDWARE_CONFIG = {
  telescopePackageId: 'rasa11_x6',
  sensorId: 'zwo6200',
  infrastructure: {
    mountSystem: 45000,
    enclosure: 35000,
    acquisitionElectronics: 25000,
    powerCabling: 22600,
  },
};

export const TELESCOPE_PACKAGES = {
  rasa11_x6: {
    id: 'rasa11_x6',
    label: '6× RASA 11',
    count: 6,
    unitCost: 3500,
    aperture: 11,
    focalRatio: 2.2,
  },
  rasa14_x4: {
    id: 'rasa14_x4',
    label: '4× RASA 14',
    count: 4,
    unitCost: 14000,
    aperture: 14,
    focalRatio: 2.2,
  },
};

export const SENSORS = {
  zwo6200: {
    id: 'zwo6200',
    label: 'ZWO ASI6200',
    unitCost: 4400,
    megapixels: 62,
    sensorWidth: 36,
    sensorHeight: 24,
    pixelSize: 3.76,
  },
  atik_apx60: {
    id: 'atik_apx60',
    label: 'ATIK APX60',
    unitCost: 7500,
    megapixels: 62,
    sensorWidth: 43.8,
    sensorHeight: 32.9,
    pixelSize: 3.76,
  },
  qhy411: {
    id: 'qhy411',
    label: 'QHY411',
    unitCost: 50000,
    megapixels: 151,
    sensorWidth: 43.8,
    sensorHeight: 32.9,
    pixelSize: 3.76,
  },
};

/** Per-module infrastructure line items (editable in hardware costing tool). */
export const INFRASTRUCTURE_LINES = [
  { id: 'mountSystem', name: 'Mount system (per module)' },
  { id: 'enclosure', name: 'Enclosure / shelter (per module)' },
  { id: 'acquisitionElectronics', name: 'Acquisition electronics (per module)' },
  { id: 'powerCabling', name: 'Power & cabling (per module)' },
];

export function getDefaultInfrastructure() {
  return { ...DEFAULT_HARDWARE_CONFIG.infrastructure };
}

export function getTelescopePackage(id) {
  return TELESCOPE_PACKAGES[id] ?? TELESCOPE_PACKAGES.rasa11_x6;
}

export function getSensor(id) {
  return SENSORS[id] ?? SENSORS.zwo6200;
}
